export default __webpack_public_path__ + "static/media/circle-pause.54051bcf.svg";